import React, { Component } from 'react';
import mapboxgl from 'mapbox-gl';

import 'mapbox-gl/dist/mapbox-gl.css';

import { MAPBOX_TOKEN } from './constants';

export default class DistrictMap extends Component {
  constructor(props) {
    super(props);
    this.attach = React.createRef();
  }

  componentDidMount() {
    this.buildMap();
  }

  buildMap() {
    mapboxgl.accessToken = MAPBOX_TOKEN;

    const {
      dataFetch: { data },
    } = this.props;
    const [geojson] = data;
    const map = new mapboxgl.Map({
      container: this.attach.current,
      center: [-99.176201, 31.731518], // center of Texas
      zoom: 5,
      minZoom: 5,
      maxZoom: 13,
      scrollZoom: false,
      dragPan: false,
      style: 'mapbox://styles/mapbox/streets-v11',
    });
    const lngLat = new mapboxgl.LngLatBounds(geojson.bbox);

    map.addControl(new mapboxgl.NavigationControl());
    map.fitBounds(lngLat, { padding: 50 });
    map.on('load', () => {
      map.addLayer({
        id: 'district',
        type: 'fill',
        source: {
          type: 'geojson',
          data: geojson,
        },
        paint: {
          'fill-color': 'rgba(83,155,174,.6)',
          'fill-outline-color': '#000',
        },
      });
    });
    map.on('click', () => {
      map.dragPan.enable();
      map.scrollZoom.enable();
    });

    // disable map rotation using right click + drag
    map.dragRotate.disable();

    // disable map rotation using touch rotation gesture
    map.touchZoomRotate.disableRotation();
  }

  render() {
    return (
      <figure>
        <div className="c-district-map has-xxs-btm-marg" ref={this.attach} />
        <figcaption>
          Click or tap the map to enable panning and zooming.
        </figcaption>
      </figure>
    );
  }
}
